import * as THREE from 'three'
import React, { useRef, useEffect, useState } from 'react'
import { useThree, useLoader } from '@react-three/fiber'

export default function Sound({ url, playSound }) {
  const { camera } = useThree()
  const sound = useRef()
  const [listener] = useState(() => new THREE.AudioListener())
  const buffer = useLoader(THREE.AudioLoader, url)
  var volume

  

  useEffect(() => {
    if (playSound) {
      
      sound.current = new THREE.PositionalAudio(listener); // Create positional audio with the listener
      sound.current.setBuffer(buffer);
      sound.current.setLoop(false);
      sound.current.setRefDistance(10); // Adjust reference distance
      sound.current.setMaxDistance(10); // Adjust max distance
      sound.current.play();
      listener.setMasterVolume(0.1); // Adjust volume if needed

    
    } else if (sound.current) {
      sound.current.stop();

    }
    return () => {
      // Clean up audio on unmount
      if (sound.current) {
        sound.current.stop();
       
      }
    };
  }, [playSound, buffer, camera, listener]);

  return null; // No need to render anything directly
}
